import config from 'cfg';
import {
    ADD_DEFAULT_COMMON_DICTIONARY,
    LOAD_COMMON_DICTIONARY,
    CHANGE_I18_TABLE_ITEM,
    SELECT_SECONDARY_LANG,
} from './constants';

const commonI18DashboardDefault = {
    supportedLanguages: config.supportedLanguages,
    defaultLanguage: 'en',
    secondaryLanguage: '',
    i18: {},
    statsDefault: {},
    statsList: [],
    LANGUAGES: {
        en: 'English',
        da: 'Danish',
        no: 'Norwegian',
        de: 'Deutsch',
        fi: 'Finish',
        th: 'Thai',
        se: 'Swedish',
        sc: 'Chinise simpl',
        tc: 'Chinise trad',
    },
};

export default (commonI18Dashboard = commonI18DashboardDefault, { type, payload }) => {
    switch (type) {
        case ADD_DEFAULT_COMMON_DICTIONARY: {
            const en = { ...payload.commonDictionaryEn, ...payload.entities.i18.en };

            return {
                ...commonI18Dashboard,
                i18: payload.entities.i18,
                statsDefault: en,
                statsList: Object.keys(en).sort(),
            };
        }

        case LOAD_COMMON_DICTIONARY: {
            const en = (payload.i18 && payload.i18.en) || {};

            return {
                ...commonI18Dashboard,
                i18: payload.i18,
                statsDefault: en,
                statsList: Object.keys(en).sort(),
            };
        }

        case SELECT_SECONDARY_LANG:
            return {
                ...commonI18Dashboard,
                secondaryLanguage: payload.lang,
            };

        case CHANGE_I18_TABLE_ITEM: {
            const lang = payload.lang === 'secondary' ? commonI18Dashboard.secondaryLanguage : payload.lang;
            const i18 = {
                ...commonI18Dashboard.i18,
                [lang]: {
                    ...commonI18Dashboard.i18[lang],
                    [payload.label]: payload.value,
                },
            };

            if (payload.value === '') {
                Reflect.deleteProperty(i18[lang], payload.label);
            }

            return {
                ...commonI18Dashboard,
                i18,
            };
        }

        default:
            return commonI18Dashboard;
    }
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/reducer.js
 **/